<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <div style="width: 100%; height: 100%">
        <keep-alive >
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </transition>
    <div class="beian-info">
      <a href="https://beian.miit.gov.cn/" target="_blank">
        备案号：浙ICP备2024106504号
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>

<style scoped>
.app-main {
  position: relative;
  padding-bottom: 40px; /* 为固定定位的备案信息留出空间 */
}

.beian-info {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  background-color: #fff;
  border-top: 1px solid #eee;
  z-index: 999;
}

.beian-info a {
  color: #333;
  text-decoration: none;
}

.beian-info a:hover {
  color: #000;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue